export default {
 template: require('./wtg-user-create.html'),
 controller: function($scope,$rootScope,$sce,INTERACT,IDA,L) {
  $scope.strings=$rootScope.strings;
  this.$onInit = function() {
   var myself = INTERACT.get_myself();
   if(myself)
    $scope.url_ida = $sce.trustAsResourceUrl(
     IDA.get_url('create-account',{selfid:myself.id}) );
   else L.warn("Can't make up create account URL while not being self-aware");
  };
 }
};
